    <app-header></app-header>


    <!-- main content -->
    <div class="content">
        <div class="steps-wrapper">
            <div class="message">
                <div class="message__step message__step--active step-message-1">
                    <p class="font-light">3 de 4</p>
                    <h2 class="text-2xl font-medium mt-5 mb-10">Detalle su cita<br/>médica particular</h2>
                </div>

            </div>
            <div class="progress">
                <div class="progress__step step-1-ico progress__step--done"><span class="progess__step-text">Datos personales</span></div>
                <div class="progress__step step-2-ico progress__step--done"><span class="progess__step-text">Horarios y Doctores</span></div>
                <!-- <div class="progress__step step-3-ico progress__step--done"><span class="progess__step-text">Cuenta OSI</span></div> -->
                <div class="progress__step progress__step--active step-3-ico"><span class="progess__step-text">Cobertura, condiciones y pago</span></div>
                <div class="progress__step step-4-ico"><span class="progess__step-text">Resumen</span></div>
            </div>
        </div>


        <div class="form-wrapper" *ngIf="citalibre">
            <form [formGroup]="appointmentForm">
                <h3 class="form-reservation__title">Consulte su cobertura</h3>
                <div class="field-group">
                    <label class="label" for="seguro">¿Cuenta con seguro?</label>
                    <select class="field" (change)="onChange($event.target.value)" >
                        <option *ngFor="let item of condicionales" [ngValue]="item.idcondicional">
                        {{item.abreviatura}}</option>
                    </select>
                </div>

                <div id="selectTiposeguro"  class="field-group hidden"  >
                    <label class="label" for="tipo_seguro">Seleccione el seguro</label>
                    <select class="field" [(ngModel)]="selectedseguro" [ngModelOptions]="{standalone: true}" (change)="onSelect($event.target.value)">
                        <option disabled >Seleccione</option>
                        <option *ngFor="let item of seguros" >
                            {{item.name}}</option>
                    </select>
                </div>

                <div class="field-group" *ngIf="formSiSeguro">
                    <label>Seleccione su plan de seguro</label>
                    <select [(ngModel)]="selectedplan" (ngModelChange)="onChangePlan($event)" [ngModelOptions]="{standalone: true}"
                        class="custom-select d-block w-100 border-round-2" style="position: relative;
                        cursor: pointer;
                        background-color: transparent;
                        border: 0.5px solid #616F77;
                        border-radius: 4px;
                        outline: none;
                        height: 46px;
                        line-height: 3rem;
                        width: 100%;
                        font-size: 14px;
                        margin: 6px 0 0 0;
                        padding: 12px 16px;
                        display: block;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                        z-index: 1;">
                        <option *ngFor="let item of planes" [ngValue]="item.idplan+'-'+item.plan">
                            {{item.name}}</option>
                    </select>

                </div>

                <hr>

                <div *ngIf="formSiSeguro">
                    <button id="button-continue__step-3" (click)="consultar_cobertura()" class="button bg-green-1 " type="button" >Consultar Cobertura</button>
                </div>
                <br>


            </form>

            <form [formGroup]="detalleForm" (ngSubmit)="openPagar()" *ngIf="formNoSeguro" novalidate>
                <div id="resume" class="form-reservation__section resume">
                    <h3 class="form-reservation__title">Tiene una reserva con nosotros</h3>

                    <div class="resume__wrapper">
                        <div class="resume__schedule md:flex">
                            <div class="resume__section md:flex-1">
                                <p>Paciente:</p>
                                <p class="font-bold">{{detalle.paciente}}</p>
                            </div>
                            <div class="resume__section md:flex-1">
                                <p>Sede:</p>
                                <p class="font-bold">{{detalle.sede}}</p>
                            </div>


                        </div>
                    </div>
                    <div class="resume__wrapper">
                        <div class="resume__schedule md:flex">
                            <div class="resume__section md:flex-1">
                                <p>Fecha de la cita médica:</p>
                                <p class="font-bold"> {{detalle.fecha | date:'EEEE, d \'de\' MMMM y' | titlecase}}</p>
                            </div>
                            <div class="resume__section md:flex-1">
                                <p>Hora de la cita médica:</p>
                                <p class="font-bold">{{detalle.hora | date:'h:mm a' }}</p>
                            </div>
                        </div>
                    </div>

                    <div class="resume__wrapper">
                        <div class="resume__section">
                            <p>Especialista que atenderá su consulta:</p>
                        </div>
                    </div>
                    <div class="card">
                        <div class="doctor">
                            <img class="doctor__image" src="./assets/images/doctores/{{detalle.idmedico}}.jpg" onError="this.src='./assets/images/doctores/icon_doctor.jpg'" alt="Doctor 2">
                            <div class="doctor__content">
                                <p class="doctor__fullname">
                                    <span class="doctor__name">{{detalle.sexo == 'F' ? 'Dra.' :' Dr. '}} {{detalle.medico}}</span>
                                </p>
                                <p class="doctor__cmp">Especialidad: <span>   Medicina Física y Rehabilitación</span></p>

                            </div>
                        </div>
                    </div>
                    <div class="resume__wrapper">
                        <div class="resume__consult-type resume__section">
                            <p>Monto a pagar:</p>
                            <p class="font-bold"> S/. {{detalle.precioDet  }}</p>
                        </div>

                    </div>

                    <div class="field-group-checkbox">
                        <input class="field-group-checkbox__field" type="checkbox" checked name="policy" id="policy">
                        <label class="field-group-checkbox__label" for="policy"> Al pagar estás aceptando nuestros <a target="_blank" class="link"
                            href="https://www.centromedicoosi.com/terminos-y-condiciones">
                            Términos y Condiciones </a>.</label>
                    </div>

                    <div class="alert alert-danger animate__animated animate__headShake" role="alert"
                        *ngIf="detalleForm.invalid">
                        Debe aceptar nuestros términos y condiciones.
                    </div>
                    <hr>

                      <div class="resume__wrapper">
                        <div class="resume__section">
                            <p>Medios de pago:</p>
                        </div>
                    </div>

                    <div class="osi-radio-group" style="justify-content:center"  >
                        <!-- radio button 1 -->
                        <div class="osi-radio" style="width: 45%;" >
                            <input id="osi-radio-izipay" type="radio" [disabled]="!detalleForm.valid" formControlName="mediopago" name="mediopago"
                                value="izipay" (change)="changeMedio($event.target.value)" />
                            <label for="osi-radio-izipay" class="osi-radio--label">
                                <span class="osi-radio--button"></span>
                                <div class="alineado ancho50" style="margin-left:10px">
                                    <img src="assets/img/vinetaTarjeta.png" class="margenIzquierdo10 margenSuperior10" />
                                    </div>
                                <p>Tarjeta de Crédito o débito</p>
                            </label>
                        </div>
                        <div class="osi-radio" style="width: 45%;"  >
                            <input id="osi-radio-pagoefectivo" type="radio" [disabled]="!detalleForm.valid" formControlName="mediopago" name="mediopago"
                                value="pagoefectivo" (change)="changeMedio($event.target.value)" />
                            <label for="osi-radio-pagoefectivo" class="osi-radio--label">
                                <span class="osi-radio--button"></span>
                                <div class="alineado ancho50" style="margin-left: 10px;" >
                                    <img src="assets/img/vinetaPagoEfectivo.png" class="margenIzquierdo10 margenSuperior10" />
                                    </div>
                                <p>Pagoefectivo</p>
                            </label>
                        </div>
                    </div>

                    <div class="resume__wrapper" style="justify-content:center">


                            <div id="button_pago"></div>
                            <div style="text-align: center;">
                                <button id="btn_pagoefectivo" style="display: none;" class="button bg-blue-1" (click)="save_pagoefectivo()" type="button">Generar CIP</button>
                            </div>
                            <br>

                        </div>
                    </div>

                <button style="display: none;" id="button_page" type="submit"></button>
            </form>
            <input type="hidden" id='response_page' name='response_page' value="" />
                <input type="hidden" id="error_form" name="error_form" value="" />
                <button style="display: none;" ng-click="vm.error_form()" id="button_errorForm"></button>

            <div class="btn-volver-atras-wrapper">
                <a (click)="VolverAtras()" class="btn-volver-atras">
                    <i class="fa fa-arrow-left"></i> Volver atrás
                </a>
            </div>

        </div>


</div>
<div class="overlay_sede" id="overlay"></div>
<div class="modal" id="modal" >
    <div  class="form-reservation__section" style="text-align: center;">
        <h3 class="form-reservation__title">Alerta</h3>
        <div class="resume__wrapper">
            <div class="resume__section">
                <p>Asegúrese de haber elegido bien su seguro o comuníquese con nuestra central telefónica. (01) 7390888</p>
            </div>
        </div>
        <div class="resume__wrapper">
            <button type="button" style="display: inline;" (click)="closeModal()" class="button bg-blue-1" >Cerrar</button>
        </div>
    </div>

</div>

<div class="modal" id="modal_cita" *ngIf="!MedioPago">
    <div  class="form-reservation__section" style="text-align: center;">
        <h3 class="form-reservation__title">Alerta</h3>
        <div class="resume__wrapper">
            <div class="resume__section">
                <p>{{detallecitas.error}}, para poder ayudarlo comuníquese con nuestra central telefónica. (01) 7390888</p>
            </div>
        </div>
        <div class="resume__wrapper">
            <button type="button" style="display: inline;" (click)="closeModalCita()" class="button bg-blue-1" >Cerrar</button>
        </div>
    </div>

</div>

<div class="modal" id="modal_cita_appoiment" *ngIf="!MedioPago">
    <div  class="form-reservation__section" style="text-align: center;">
        <h3 class="form-reservation__title">Alerta</h3>
        <div class="resume__wrapper">
            <div class="resume__section">
                <p>{{detallecitas.error}}</p>
            </div>
        </div>
        <div class="resume__wrapper">
            <button type="button" style="display: inline;" (click)="closeModalCita()" class="button bg-blue-1" >Cerrar</button>
        </div>
    </div>

</div>

<ngx-spinner  [fullScreen]="true" bdColor = "rgba(0, 0, 0, 0.8)"><p class="loading" >Espere un momento por favor...</p></ngx-spinner>

<ngx-spinner name="carrera2" [fullScreen]="true" bdColor = "rgba(0, 0, 0, 0.8)"><p class="loading" >Estamos buscando tu cobertura...</p></ngx-spinner>

<ngx-spinner name="carrera3" [fullScreen]="true" bdColor = "rgba(0, 0, 0, 0.8)"><p class="loading" >Falta muy poco para culminar tu reserva...</p></ngx-spinner>

<ngx-spinner name="carrera4" [fullScreen]="true" bdColor = "rgba(0, 0, 0, 0.8)"><p class="loading" >Buscando...</p></ngx-spinner>

